import { render, staticRenderFns } from "./MedicineStockMngt.vue?vue&type=template&id=06b9eea7"
import script from "./MedicineStockMngt.vue?vue&type=script&lang=js"
export * from "./MedicineStockMngt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports